import React from "react";

/** Medic'help mark: a soft purple squircle with a medical cross. */
export default function Logo({ size = 36 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
            <defs>
                <linearGradient id="mh-logo" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#8E78F2" />
                    <stop offset="1" stopColor="#4A31C2" />
                </linearGradient>
            </defs>
            <rect width="40" height="40" rx="12" fill="url(#mh-logo)" />
            <path d="M17 10h6v7h7v6h-7v7h-6v-7h-7v-6h7z" fill="#fff" />
        </svg>
    );
}
